const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const assign = require('object-assign');
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Button = FuzzyReaction.Components.Global.Button;
const ActivationCodeStore = require('../../../stores/ActivationCodeStore');
const GenerationCodeStore = require('../../../stores/CodeStore');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
const CodeDetail = createReactClass({
    displayName: 'CodeDetail',

    getInitialState: function () {
        return {
            currentPageData: [],
            codeInfo: {},
            params: {},
            openDeactivateModal: false,
            workingResource: {}
        }
    },

    getOptions: {
        modifiers: {
            include: ['generation_code_id', 'id', 'code'],
            filters: {}
        },
        dataNode: 'data'
    },

    getOptionsCode: {
        modifiers: {
            include: [],
            filters: {},
            pagination: {
                per_page: '100'
            }
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            include: ['id', 'code', 'used'],
            filters: {},
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data',
        refresh: 'list'
    },

    resourceActions: new ResourceActions('activation-codes'),
    resourceCode: new ResourceActions('generation-codes'),

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        const userId = this.state.params.id;

        if (modifiers == null) {
            this.getOptions.modifiers = {
                filters: {generation_code_id: "~" + userId}
            }
        } else if (modifiers.filters === undefined) {
            this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});
        } else {
            modifiers.filters.generation_code_id = "~" + userId;
            this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});
        }

        this.resourceActions.listResource(this.getOptions);
    },

    requestCodeData: function (modifiers) {
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});
        this.resourceCode.listResource(this.getOptionsCode);
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        const params = this.props.match.params || {};

        this.setState({
            params: params,
            resourceOperation: typeof params.id === 'undefined' ? 'create' : 'edit'
        }, function () {
            // An existing user
            if (this.state.resourceOperation === 'edit') {
                this.requestTableData();
                this.requestCodeData();
            }
        });
        this.changeListener = this._onChange;
        ActivationCodeStore.addChangeListener(this.changeListener);
        GenerationCodeStore.addChangeListener(this.changeListener);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        ActivationCodeStore.removeChangeListener(this.changeListener);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        const userId = this.state.params.id === 'me' ? this.state.workingResource.id : this.state.params.id;
        this.setState({

            currentPageData: ActivationCodeStore.getResource(),
            codeInfo: GenerationCodeStore.getResourceById(userId)

        });
    },

    /**
     * @todo the modals can be their own components
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'goBack':
                this.props.history.push('/codes');
                break;
        }
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            openDeactivateModal: false,
            workingResource: {} // Reset working resource
        });
    },

    /**
     * Map instructor object properties to table columns
     */
    tableKeys: {
        "Code": "code",
        "Used": "used"
    },

    render: function () {
        // Set up table options
        var tableOptions = {
            actionsCallback: this.handleAction
        };

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"></div>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="8">
                            <h1 className="page-header">Active Codes</h1>
                        </Column>

                        <Column grid="lg" size="4">
                            <div className="page-header">
                                <PageSearch actionMethod={this.requestTableData}
                                            searchable={['code']}/>
                            </div>
                        </Column>

                    </Row>
                    <Row>
                        <Column grid="lg" size="6">
                            <h4>Prefix: {this.state.codeInfo.prefix != null ? this.state.codeInfo.prefix : ''}</h4>
                        </Column>
                        <Column grid="lg" size="6">
                        </Column>
                        <Column grid="lg" size="6">
                        </Column>

                    </Row>
                    <Row>
                        <Column grid="lg" size="6">
                            <h5>Expiration: {this.state.codeInfo.expiration != null ? this.state.codeInfo.expiration : ''}</h5>
                        </Column>
                        <Column grid="lg" size="6">
                        </Column>
                        <Column grid="lg" size="6">
                        </Column>

                    </Row>
                    <Row>
                        <Column grid="lg" size="6">
                            <h5>Length: {this.state.codeInfo.num_days != null ? this.state.codeInfo.expiration : ''}</h5>
                        </Column>
                        <Column grid="lg" size="6">
                        </Column>
                        <Column grid="lg" size="6">
                        </Column>

                    </Row>
                    <Row>
                        <Column grid="lg" size="12">
                            <Table data={this.state.currentPageData}
                                   dataKeys={this.tableKeys}
                                   title={'Codes'} options={tableOptions}/>
                            <Paginator actionMethod={this.requestTableData}/>

                            <PerPageSelector actionMethod={this.requestTableData}/>
                        </Column>
                    </Row>
                    <Row classes="justify-content-end">
                        <Button action="goBack" text="Go Back" handleAction={this.handleAction}
                                mods={['primary']}/>
                    </Row>
                </div>
            </div>
        )
    },
});

module.exports = CodeDetail;
